import JobListPage from './list/'
import JobViewPage from './view/'

export default {
  JobListPage,
  JobViewPage
}
